import { render, staticRenderFns } from "./PmauInstitutionalTeam.vue?vue&type=template&id=11d57ee2&scoped=true&"
import script from "./PmauInstitutionalTeam.vue?vue&type=script&lang=js&"
export * from "./PmauInstitutionalTeam.vue?vue&type=script&lang=js&"
import style0 from "./PmauInstitutionalTeam.vue?vue&type=style&index=0&id=11d57ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d57ee2",
  null
  
)

export default component.exports